import { AxiosResponse, CancelTokenSource } from 'axios';
import API from './index';
import { Menu } from './menu.api';

const api = new API();

export namespace UpsellAPINS {
  export interface MenuWithIsAvailable extends Menu {
    isAvailable: boolean;
    timesStr: string[];
  }

  export interface UpsellWithData {
    menus: Array<{ floorPlanId: number; menus: MenuWithIsAvailable[] }>;
    floorPlans: Array<{ id: number; name: string; description: string }>;
    onlineMenuMandatory: boolean;
    availableALaCarteFloorPlanIds: number[];
    currency: string;
    locale: string;
  }
}

export const getUpsell: (
  restaurantId: number,
  date: string,
  guests: number,
  eventId: number | null,
  cancelToken: CancelTokenSource,
) => Promise<AxiosResponse<UpsellAPINS.UpsellWithData>> = (
  restaurantId,
  date,
  guests,
  eventId,
  cancelToken,
) => {
  return api._get(`/web/upsell/${restaurantId}/${date}/${guests}/${eventId}`, {
    cancelToken: cancelToken.token,
  });
};
